<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      :show-save-button="$permission.canEdit()"
      unit="轮播图"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="95px"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      :get-data-func="api.info"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="轮播图名称" prop="PhotoName">
              <el-input
                v-model="data.PhotoName"
                placeholder="请填写轮播图名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="链接类型" prop="PhotoType">
              <el-select
                v-model="data.PhotoType"
                placeholder="请选择链接类型"
                clearable
              >
                <el-option label="静态展示" :value="0"></el-option>
                <el-option label="商品分类" :value="1"></el-option>
                <el-option label="指定商品" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="isMB ? 24 : 12">
            <el-form-item label="链接地址" prop="LinkAddress">
              <el-input
                v-model="data.LinkAddress"
                placeholder="请填写链接地址"
                clearable
              ></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="24" v-if="data.PhotoType == 1">
            <el-form-item label="商品分类" prop="GoodsTypeId">
              <tree-select
                ref="treeSelect"
                :props="props"
                :options="TypePlatforms"
                :value="data.GoodsTypeId"
                :clearable="false"
                :accordion="true"
                :parentSelect="true"
                placeholder="请选择"
                @node-select="onTreeSelect($event)"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="data.PhotoType == 2">
            <el-form-item label="商品名称" prop="GoodsName">
              <el-input
                v-model="data.GoodsName"
                placeholder="点击选择"
                readonly
                suffix-icon="el-icon-search"
                @focus="onGoodsDialog"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
            <el-col :span="24">
              <el-form-item label="电脑端图片上传" prop="PhotoAddress">
                <single-pic-upload
                  v-model="data.PhotoAddress"
                  type="PhotoAddress"
                  :uploadUrl="uploadUrl"
                ></single-pic-upload>
              </el-form-item>
            </el-col>
          </el-row> -->

        <el-row>
          <el-col :span="24">
            <el-form-item label="图片上传" prop="PhotoAddressmobile">
              <single-pic-upload
                v-model="data.PhotoAddressmobile"
                type="PhotoAddressmobile"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
              <span style="color: red">最佳宽长比例4：9</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="状态" prop="State">
              <el-radio-group v-model="data.State">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <goods-dialog
      ref="goodsDialog"
      in-dialog
      selectable
      :multiple="false"
      @select="setGoods"
    />
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";
import treeSelect from "@/components/common/treeSelect";
import goodsDialog from "@/components/goods/info/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
    treeSelect,
    goodsDialog,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        PhotoType: 0,
        PhotoName: "",
        PhotoAddress: "",
        PhotoAddressmobile: "",
        LinkAddress: "",
        OrderId: 0,
        State: 1,
        GoodsTypeId: null,
        GoodsId: null,
        GoodsName: "",
      },

      api: require("@/api/mall/loopphoto").default,
      api2: require("@/api/goods/typeplatform").default,

      isMB: this.$store.state.isMB,
      rules: {
        PhotoName: [{ required: true, message: "图片名称不能为空" }],
        //PhotoAddress: [{ required: true, message: "请上传电脑端图片" }],
        PhotoAddressmobile: [{ required: true, message: "请上传图片" }],
        LinkAddress: [{ validator: this.$commonJs.validateRules.validUrl }],

        OrderId: [{ required: true, message: "序号不能为空" }],
      },
      uploadUrl: "/api/Common/UploadPicture",
      TypePlatforms: [],
      props: {
        value: "RecordId",
        label: "TypeName",
        children: "children",
      },
    };
  },
  beforeMount() {
  },
  methods: {
    getOption() {
      this.api2.list({ State: 1 }).then((res) => {
        if (res.Code == 0) {
          this.TypePlatforms = this.$commonJs.toTreeData(
            res.Data,
            "RecordId",
            "TypeIdParent",
            "children"
          );
          if(this.$refs.treeSelect){
            this.$refs.treeSelect.setData();
          }
        }
      });
    },
    onGoodsDialog() {
      this.$refs.goodsDialog.open().then((that) => {
        that.getData({ SaleState: 1 });
        that.getTree();
      });
    },
    setGoods(t) {
      console.log(t, "setgoods");
      this.data.GoodsId = t.RecordId;
      this.data.GoodsName = t.GoodsName;
    },
    onTreeSelect(t) {
      if (!t) {
        this.data.GoodsTypeName = "";
        this.data.GoodsTypeId = null;
      } else {
        this.data.GoodsTypeName = t.TypepName;
        this.data.GoodsTypeId = t.RecordId;
      }
    },
    onCreateOpened(row) {
      this.getOption();
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    onEditOpened(row) {
      this.getOption();
    },
    onBeforeSave() {},
    onClosed() {},
  },
};
</script>